import FileCopyIcon from '@material-ui/icons/FileCopy';
import { CSSProperties, FC, useMemo } from 'react';
import { Log } from '../../../types';
import { CopyButton } from '../../CopyButton';
import { WbCard } from '../../WbCard';
import { WbLogsViewer } from '../WbLogsViewer';
import { stringifyLogs } from './utils';

const styles = {
  button: {
    minWidth: 0,
  },
  icon: {
    width: '20px',
    height: '20px',
  },
};

interface Props {
  title: string;
  logs?: Log[];
  text?: string;
  language?: string;
  style?: CSSProperties;
  className?: string;
}

export const WbLogsCard: FC<Props> = ({
  logs,
  text,
  title,
  language,
  style,
  className,
}) => {
  const logText = useMemo(
    () =>
      logs && logs.length > 0
        ? stringifyLogs(logs)
        : text || 'No data available',
    [logs, text],
  );

  return (
    <WbCard
      cardStyle={{ ...style }}
      cardClassName={className}
      title={title}
      actions={
        (logs && logs.length > 0) || text ? (
          <CopyButton
            text={logText}
            hideIcon
            size="small"
            color="secondary"
            variant="text"
            style={styles.button}
          >
            <FileCopyIcon style={styles.icon} />
          </CopyButton>
        ) : undefined
      }
    >
      <WbLogsViewer text={logText} language={language} />
    </WbCard>
  );
};
